module.exports = __webpack_public_path__ + "img/rank_1.4d08a0f4.png";